<nb-layout windowMode>
  <nb-layout-header fixed>
    <div class="nav-wrapper">
      <div class="header-container">
        <div class="logo-container">
          <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
            <nb-icon icon="menu-2-outline"></nb-icon>
          </a>
          <a class="logo" href="#">Russell's Portal</a>
        </div>
      </div>
      <div class="header-container">
        <nb-select
          class="margin"
          size="tiny"
          [selected]="currentTheme"
          (selectedChange)="themeService.changeTheme($event); saveThemePreference($event)"
          status="primary"
          *ngIf="!(layoutService.$isHandset | async)"
        >
          <nb-option *ngFor="let theme of themes" [value]="theme.value">
            {{ theme.name }}</nb-option
          >
        </nb-select>
        <nb-actions size="tiny">
          <nb-action class="user-action">
            <nb-user
              *ngIf="authService.$user | async as user"
              [onlyPicture]="false"
              [title]="claims.roles[0]"
              [name]="user.displayName"
              [picture]="user.photoURL"
              [nbContextMenu]="userMenu"
            >
            </nb-user>
          </nb-action>
        </nb-actions>
      </div>
    </div>
  </nb-layout-header>
  <nb-sidebar tag="menu-sidebar" responsive compactedBreakpoints="[]" #sidebar>
    <nb-menu [items]="menu"></nb-menu>
    <div class="row">
      <div class="col-xs-12">
        <label *ngIf="layoutService.$isHandset | async" class="margin margin-top">
          <strong>Theme: </strong>
        </label>
        <nb-select
          size="tiny"
          [selected]="currentTheme"
          (selectedChange)="themeService.changeTheme($event); saveThemePreference($event)"
          status="primary"
          *ngIf="layoutService.$isHandset | async"
        >
          <nb-option *ngFor="let theme of themes" [value]="theme.value">{{ theme.name }}</nb-option>
        </nb-select>
      </div>
    </div>
  </nb-sidebar>

  <nb-layout-column>
    <ng-content select="router-outlet"></ng-content>
  </nb-layout-column>

  <!-- <nb-layout-footer fixed>
    Footer
  </nb-layout-footer> -->
</nb-layout>
